import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const ProjectsAll = () => {
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [p, c] = await Promise.all([api.get("/projects"), api.get("/clients")]);
        setProjects(p.data);
        const map = {};
        c.data.forEach((cl) => (map[cl.id] = cl));
        setClients(map);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="projects-page">
      <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#9c95a8]">In flight</p>
      <h1 className="font-display text-4xl font-bold tracking-tight mt-2">Projects</h1>
      <p className="text-[#bdb6c4] mt-2">Every active and past build, across all clients.</p>

      <div className="mt-8 space-y-2" data-testid="projects-list">
        {loading ? (
          <p className="text-[#9c95a8] text-sm">Loading…</p>
        ) : projects.length === 0 ? (
          <p className="text-[#9c95a8] text-sm">No projects yet. Open a client to create their first one.</p>
        ) : (
          projects.map((p) => {
            const totalTasks = (p.stages || []).reduce((a, s) => a + (s.tasks?.length || 0), 0);
            const doneTasks = (p.stages || []).reduce((a, s) => a + (s.tasks?.filter((t) => t.done).length || 0), 0);
            const activeStage = (p.stages || []).find((s) => s.status === "active")?.name || "—";
            const c = clients[p.client_id];
            return (
              <Link
                key={p.id}
                to={`/admin/projects/${p.id}`}
                className="block bg-[#13121f] border border-white/10 rounded-xl px-5 py-4 hover:border-[#f5c76e]/30 transition-colors"
              >
                <div className="flex justify-between items-start gap-3 flex-wrap">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <p className="font-medium">{p.name}</p>
                      {p.app_type && <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#6b6677]">{p.app_type}</span>}
                      <span className={`font-mono text-[10px] uppercase tracking-[0.22em] px-2 py-0.5 rounded border ${
                        p.status === "active" ? "border-[#f5c76e]/40 text-[#f5c76e]" :
                        p.status === "launched" ? "border-emerald-400/40 text-emerald-400" :
                        p.status === "paused" ? "border-blue-400/40 text-blue-300" :
                        "border-white/15 text-[#9c95a8]"
                      }`}>{p.status}</span>
                    </div>
                    <p className="text-sm text-[#bdb6c4] mt-1">
                      {c?.name || "—"} · stage: <span className="text-[#f5c76e]">{activeStage}</span> · {doneTasks}/{totalTasks} tasks done
                    </p>
                  </div>
                </div>
              </Link>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ProjectsAll;
